import React, { useState } from 'react';

import { getPathByRoute } from 'App.js';
import routeKeys from 'CustomerRouteKeys.js';

import TransferProvider from 'context/TransferContext.js';
import PurseBalanceProvider from 'context/PurseBalanceContext.js';
import TransitAccountIdContext, { useTransitAccountIdContext } from 'context/TransitAccountIdContext.js';
import { StepContextProvider, useStepContext } from 'context/StepContext.js';
import { useTransitAccount } from 'components/data/transit-account/TransitAccount.js';

import TransferProducts from './card/TransferProducts.js';
import DeLinkCard from './DeLinkCard.js';
import CmsContentRenderedInline from 'components/data/CmsContentRenderedInline.js';
import { ComponentLoading } from 'components/icons/LoadingIcon.js';

const cms = {
	headerDelink: 'miscText.remove-transit-header',
	delinkStepOneHeader: 'miscText.remove-transit-transfer-step',
	delinkStepTwoHeader: 'miscText.remove-transit-review-step',
};

const DELINK_FLOW_SELECT_PRODUCTS = 0;
const DELINK_FLOW_CONFIRMATION = 1;

export const DELINK_FLOW_STEPS = [
	{
		step: DELINK_FLOW_SELECT_PRODUCTS,
		label: <CmsContentRenderedInline
			contentKey={cms.delinkStepOneHeader}
			fallbackValue="Step 1: Transfer items before unlinking (optional)"
		/>,
	},
	{
		step: DELINK_FLOW_CONFIRMATION,
		label: <CmsContentRenderedInline
			contentKey={cms.delinkStepTwoHeader}
			fallbackValue="Step 2: Review & confirm"
		/>,
	},
];

/**
 * Return the current step of the flow
 */
const CurrentStep = () => {
	const transit_account_id = useTransitAccountIdContext();
	const [ hideTransfer, setHideTransfer ] = useState(false);
	const { step } = useStepContext();

	const {
		data: transitAccountQData,
		loading,
	} = useTransitAccount({ subsystemAccountReference: transit_account_id, returnTransferProductInfo: true });

	if (loading) {
		return <ComponentLoading />;
	}

	const redirectUrl = getPathByRoute(routeKeys.AccountCardOverview, { transit_account_id });

	switch (step) {
		case DELINK_FLOW_SELECT_PRODUCTS:
			return <TransferProducts { ...{ transitAccountQ: transitAccountQData.transitAccountQ, isDelink: true, takeoverTitle: cms.headerDelink, setHideTransfer }} cancelUrl={redirectUrl}  />;
		case DELINK_FLOW_CONFIRMATION:
			return <DeLinkCard  { ...{ transitAccountQ: transitAccountQData.transitAccountQ, hideTransfer }} cancelUrl={redirectUrl} />;
	};
};

const DeLinkCardFlow = () => (
	<TransitAccountIdContext.Consumer>{(subsystemAccountReference) => (
		<StepContextProvider min={DELINK_FLOW_SELECT_PRODUCTS} max={DELINK_FLOW_CONFIRMATION}>
			<PurseBalanceProvider {...{ subsystemAccountReference }}>
				<TransferProvider>
					<CurrentStep/>
				</TransferProvider>
			</PurseBalanceProvider>
		</StepContextProvider>
	)}</TransitAccountIdContext.Consumer>
);

export default DeLinkCardFlow;
